/**
 * Runtime constants for A12 meta model keys.
 * Mirrors the (type-only) IMetaKeys declare namespace which has no runtime representation.
 * Maintain this file when A12 changes its internal key strings.
 */
export const MetaKeys = {
	MODEL_META_FIELD: "MetaFeld",
	MODEL_MANDATORY_FIELDS: "PflichtFelder",
	MODEL_META_RULE: "MetaRegel",
	MODEL_META_GROUP: "MetaContainer",
	MODEL_GROUP_LIST: "ContainerListe",
	MODEL_APPLICATION_CONDITION: "ApplikationsBedingungen",
	MODEL_CUSTOM_FIELD_TYPES_TO_BE_PROVIDED: "CustomFieldtypesToBeProvided",
	MODEL_LANGUAGES: "Sprachen",
	MODEL_CALC_FIELDS: "BerechneteFelder",
	MODEL_INDEX_FIELDS: "IndexFields",
	MODEL_INDEX_FIELD_FULL_NAMES: "IndexFieldFullNames",
	MODEL_DYNAMIC_ENUM_FIELDS: "DynamicEnumFields",
	MODEL_ANNOTATION: "Annotation",
	MODEL_ALL_ANNOTATED_ENTITIES: "ALL_AnnotatedEntities",
	GROUP_SHORT_NAME: "Name",
	GROUP_FULLNAME: "PfadName",
	GROUP_SUBGROUP_LIST: "ContainerListe",
	GROUP_RULE_LIST: "RegelListe",
	GROUP_FIELD_LIST: "FelderListe",
	GROUP_MAX_INDEX: "MaxIndex",
	GROUP_INDEX_FIELDS: "IndexFields",
	GROUP_ANNOTATION: "Annotation",
	FIELD_SHORT_NAME: "Name",
	FIELD_FULLNAME: "PfadName",
	FIELD_MANDATORY_FIELD: "Pflichtfeld",
	FIELD_MANDATORY_GLOBAL_OR_IN_SURROUNDING_REPEATABLE_GROUP: "MandatoryGloballyOrForRepeatableGroup",
	FIELD_MIN_LENGTH: "MinLaenge",
	FIELD_MAX_LENGTH: "MaxLaenge",
	FIELD_FIELD_TYPE: "Feldtyp",
	FIELD_PATTERN: "Muster",
	FIELD_ERROR_MESSAGE: "Fehlertext",
	FIELD_WORD_WRAP: "Zeilenumbruch",
	FIELD_SIGN: "Vorzeichen",
	FIELD_DECIMAL_PLACES: "Nachkommastellen",
	FIELD_MAX_DECIMAL_PLACES: "MaxNachkommastellen",
	FIELD_INTEGER_DIGIT: "Vorkommastellen",
	FIELD_ZERO_ALLOWED: "NullErlaubt",
	FIELD_LEADING_ZEROS: "FuehrendeNullen",
	FIELD_FORMAT: "Format",
	FIELD_VALUE_TRUE: "WertWahr",
	FIELD_VALUE_FALSE: "WertFalsch",
	FIELD_DECIMAL_SEPARATOR: "DezimalTrenner",
	FIELD_ENUMERATION_VALUES: "EnumerationWerte",
	FIELD_ROOT_GROUP_MANDATORY_FIELD: "VordruckPflichtfeld",
	FIELD_ENUMERATION_UI_VALUES: "EnumerationOberflaechenwerte",
	FIELD_OPERANDS_SET: "OperandenMenge",
	FIELD_TARGET_SET_FOR_CALC: "ZielMengeFuerBerechnung",
	FIELD_ENUMERATION_CATEGORY_VALUES: "EnumerationCategoryValues",
	FIELD_NO_VALUE_VALIDATION: "NoValueValidation",
	FIELD_GLOBAL: "GlobalesFeld",
	FIELD_TRANSIENT: "TransientField",
	FIELD_S_VALUE: "SValue",
	FIELD_EXPLICITLY_MANDATORY: "ExplicitlyMandatory",
	FIELD_SOURCE_FIELDS_FOR_DYNAMIC_ENUM: "SourceFieldsForDynamicEnum",
	FIELD_DYNAMIC_ENUM_VALUES: "DynamicEnumValues",
	FIELD_DYNAMIC_ENUMERATION: "DynamicEnumeration",
	FIELD_INDEX_FIELD: "IndexField",
	FIELD_META_FIELD_DATE_OF_DATE_RANGE: "MetaFieldDateOfDateRange",
	FIELD_ANNOTATION: "Annotation",
	FIELD_CUSTOM_ERROR_MESSAGE_FOR_REQUIRED: "CustomErrorMessageForRequired",
	FIELD_LABEL: "DruckText",
	RULE_NAME: "Name",
	RULE_FULL_NAME: "PfadName",
	RULE_ERROR_CODE: "Fehlercode",
	RULE_TYPE: "Regelart",
	RULE_REF_ROOTGROUP_OMISSION_ERROR: "RefVordruckeAuslassungsFehler",
	RULE_ERROR_FIELD: "Fehlerfeld",
	RULE_ANNOTATION: "Annotation",
	RULE_TYPE_ERROR: "Fehler",
	RULE_TYPE_WARNING: "Hinweis",
	RULE_TYPE_INFO: "Info",
	FIELD_TYPE_STRING: "String",
	FIELD_TYPE_NUMBER: "Zahl",
	FIELD_TYPE_DATE: "Datum",
	FIELD_TYPE_DATE_RANGE: "DatumBereich",
	FIELD_TYPE_MONEY_2: "GeldBetragMitCent",
	FIELD_TYPE_MONEY_0: "GeldBetragOhneCent",
	FIELD_TYPE_YES: "Ja",
	FIELD_TYPE_YESNO: "JaNein",
	FIELD_TYPE_ENUMERATION: "Enumeration",
	FIELD_TYPE_EXT_ENUMERATION: "NichtAbgeschlosseneEnumeration"
} as const;

export type MetaKeysType = typeof MetaKeys;
